import { Injectable, inject } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { switchMap, catchError, of, map } from 'rxjs';
import * as CategoryTreeActions from './category-tree.actions';
import { CategoryTreeService } from '../service/category-tree.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class CategoryTreeEffects {
  private actions$ = inject(Actions);
  private categoryTreeService = inject(CategoryTreeService);
  private translateService = inject(TranslateService);

  init$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CategoryTreeActions.initCategoryTree),
      switchMap((_action) =>
        this.categoryTreeService.performPostRequest(this.translateService.currentLang).pipe(
          map((response) => {
            return CategoryTreeActions.loadCategoryTreeSuccess({ categories: response.categories });
          })
        )
      ),
      catchError((error) => {
        console.error('Error', error);
        return of(CategoryTreeActions.loadCategoryTreeFailure({ error }));
      })
    )
  );
}
